// extracted by mini-css-extract-plugin
export default {"contactDealer":"_7a639804","contactDealerLabel":"_4e60cbe2","phoneIcon":"_3bf50c88"};